import { AssetManagementRepository } from '../data/asset-management-repository';
import { AssetDetailResponse } from '../types/asset-types';

/**
 * Use case for fetching asset detail with version history
 */
export class GetAssetDetailUseCase {
  constructor(private readonly repository: AssetManagementRepository) {}

  async execute(assetId: number): Promise<AssetDetailResponse> {
    return this.repository.getAssetDetail(assetId);
  }
}
